module.exports = __webpack_public_path__ + "img/school_tysyz2.00073ece.png";